export { default } from './accept-modal';
